import { createSelector } from "redux-starter-kit";

export default createSelector(
  ["invited.factoringProfileAction"],
  action => action
);
